function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "meterware_v3");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.465 5.225h-14.894c-0.634-2.43-2.746-4.225-5.387-4.225-3.063 0-5.493 2.535-5.493 5.599v18.803c0 3.063 2.535 5.599 5.599 5.599h17.535c0.423 0 0.845-0.317 0.845-0.845s-0.317-0.845-0.845-0.845h-3.908l5.704-5.704v3.38c0 0.423 0.317 0.845 0.845 0.845s0.845-0.317 0.845-0.845v-21.021c-0.106-0.423-0.423-0.739-0.845-0.739zM27.62 8.711l-13.838 13.838v-3.908l11.937-11.831h2.007v1.901zM13.782 12.725l5.915-5.915h3.697l-9.613 9.613v-3.697zM13.782 10.507v-3.697h3.697l-3.697 3.697zM4.275 6.599c0-2.218 1.796-4.014 3.908-4.014s4.014 1.796 4.014 4.014v14.894c-1.056-1.056-2.43-1.69-4.014-1.69s-2.958 0.634-4.014 1.69v-14.894zM4.275 25.401c0-2.218 1.796-4.014 3.908-4.014s4.014 1.796 4.014 4.014-1.796 4.014-4.014 4.014-3.908-1.796-3.908-4.014zM13.782 25.401v-0.634l13.838-13.838v4.12l-14.261 14.366h-1.268c1.056-1.056 1.69-2.43 1.69-4.014zM19.697 29.415h-4.12l12.042-12.042v4.12l-7.923 7.923z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.718 25.401c0-1.373-1.056-2.43-2.43-2.43s-2.43 1.056-2.43 2.43 1.056 2.43 2.43 2.43 2.43-1.162 2.43-2.43zM7.338 25.401c0-0.423 0.423-0.845 0.845-0.845s0.845 0.423 0.845 0.845-0.317 0.845-0.845 0.845-0.845-0.423-0.845-0.845z"
});

var SvgMeterware = function SvgMeterware(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMeterware, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meterware.7c518848.svg";
export { ForwardRef as ReactComponent };